import { createContext } from '@synoptic/ui-kit/utils/create-context.js';
import { ReactNode, useCallback, useState } from 'react';
import { useAppLoader } from '@/routes/_app/loader';
import { UnauthenticatedActionPrompt } from './unauthenticated-action-prompt';

/** returns true if auth prompt was shown. It means action should be aborted */
export type AuthGuard = () => boolean;

const [Provider, useCtx] = createContext<AuthGuard>(
  'UnauthenticatedActionPromptContext',
);

export const AuthGuardProvider = ({ children }: { children: ReactNode }) => {
  const { authenticated } = useAppLoader();
  const [open, setOpen] = useState(false);

  const authGuard = useCallback(() => {
    if (!authenticated) {
      setOpen(true);
      return true;
    }

    return false;
  }, [authenticated]);

  return (
    <Provider value={authGuard}>
      {children}
      {authenticated ? null : (
        <UnauthenticatedActionPrompt open={open} onOpenChange={setOpen} />
      )}
    </Provider>
  );
};

// oxlint-disable-next-line react/only-export-components
export const useAuthGuard = useCtx;
